module.exports = __webpack_public_path__ + "img/logo.a7ad172.png";